import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';

import { ModalProvider } from './store/ModalContext';


import NotFound from './pages/NotFound';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
import AboutusPage from './pages/AboutusPage';
import Register from './components/Register/Register';
import RegisterConfirmation from './components/Register/RegisterConfirmation';
import DistRegConfirmation from './components/Register/DistRegConfirmation';
import FooterLinkData from './components/FooterLinks/FooterLinksData';
import AppDetailPage from './pages/AppDetailPage';
import ResourceDetailPage from './pages/ResourceDetailPage';
import LoginPage from './pages/Login';
import { useSelector } from 'react-redux';
import UserSettings from './components/Settings/UserSettings';
import UserProfile from './components/Profile/UserProfile';
import SupportPage from './pages/SupportPage';
import NotificationDetails from './components/NotificationDetails/NotificationDetails';
import ResetPassword from './components/ResetPassword/ResetPassword';
import UserActivation from './components/UserActivation/UserActivation';

function App() {

  const { currentUser } = useSelector((state) => state.user);

  return (
    <BrowserRouter>
      <ModalProvider>
        <Layout>
          <Switch>
            <Route path="/" exact>
              <HomePage />
            </Route>

            <Route path="/aboutus">
              <AboutusPage />
            </Route>

            <Route path="/login">
              {currentUser ? <Redirect to="/" /> : <LoginPage />}
            </Route>

            <Route path="/register/:jwt?">
              {currentUser ? <Redirect to="/" /> : <Register />}
            </Route>

            <Route path="/notificationDetails/:notificationid">
              {currentUser ? <NotificationDetails /> : <Redirect to="/" />}
            </Route>

            <Route path="/registerConfirmation">
              {currentUser ? <Redirect to="/" /> : <RegisterConfirmation />}
            </Route>

            <Route path="/distributorConfirmation">
              {currentUser ? <Redirect to="/" /> : <DistRegConfirmation />}
            </Route>            

            <Route path="/appdetail/:selectedAppUrl" exact>
              <AppDetailPage />
            </Route>

            <Route path="/resourcedetail/:id" exact>
              <ResourceDetailPage />
            </Route>

            <Route path="/support">
              {currentUser ? <SupportPage /> : <Redirect to="/" />}
            </Route>

            <Route path="/resetpassword">
              {currentUser ? <Redirect to='/' /> : <ResetPassword />}
            </Route>

            <Route path="/useractivation">
              {currentUser && <Redirect to='/' />}
              {!currentUser && <UserActivation />}
            </Route>

            <Route path="/settings">
              <UserSettings />
            </Route>

            <Route path="/userProfile">
              <UserProfile />
            </Route>

            <Route path="/linkdetail/:linkName" exact>
              <FooterLinkData />
            </Route>

            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Layout>
      </ModalProvider>
    </BrowserRouter>
  );
}

export default App;
